import React, { useState, useEffect } from 'react';
import { Button, Input, Select, Table } from 'antd'
import moment from 'moment';
import { bigQueryTableColumns } from './bigQueryData';
import bigQueryQueriesService from './BigQueryQueriesService';
import { throttle } from 'app/lib/utils/UiUtils';
import ContentPanel from '../shared/ContentPanel';

const { Option } = Select;
// name, dateUpdated, dateLastRun, filter, project, sort
export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
        shouldUseAsfilter: true,
    },
    {
        title: 'Date Updated',
        dataIndex: 'dateUpdated',
        key: 'dateUpdated',
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
        sorter: (a, b) => a?.dateUpdated?.localeCompare(b?.dateUpdated),
        shouldUseAsfilter: false,
    },
    {
        title: 'Date Last Run',
        dataIndex: 'dateLastRun',
        key: 'dateLastRun',
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
        sorter: (a, b) => a?.dateLastRun?.localeCompare(b?.dateLastRun),
        shouldUseAsfilter: false
    },
    {
        title: 'Type',
        dataIndex: 'query',
        key: 'query',
        render: (d) => d?.type,
        sorter: (a, b) => a?.dateLastRun?.localeCompare(b?.dateLastRun),
        shouldUseAsfilter: false
    }
];


export const formSchema = [
    {
        props: {
            name: "name",
            label: "Name"
        },
        component: Input
    },
    {
        props: {
            name: "query",
            label: "Type"
        },
        component: (props) => {

            const [bigQueryInput, setBigQueryInput] = useState({ type: props.formDefaultValue?.query?.type || "file", value: { query: props.formDefaultValue?.query?.value || "", title: "", value: "" } });
            const [bigQuerySQLs, setBigQuerySQLs] = useState([]);
            const [formValue, setFormValue] = useState({});
            const [resTableData, setResTableData] = useState([]);

            const getBigQueryQueries = async () => {
                const fetchCollections = await bigQueryQueriesService.getBigQuerySQL();
                setBigQuerySQLs(fetchCollections);
                setBigQueryInput({ ...bigQueryInput, value: props.formDefaultValue?.query?.type === undefined || props.formDefaultValue?.query?.type === "file" ? fetchCollections[0] : "" });
            }

            useEffect(() => {
                props.onChange({ value: bigQueryInput.value.query, type: bigQueryInput.type });
            }, [bigQueryInput])

            useEffect(() => {
                getBigQueryQueries()
            }, [])

            const onSaveRecord = async () => {
                try {
                    const name = props.form.getFieldValue("name");
                    await bigQueryQueriesService[props.formDefaultValue?._id === "new" ? "createBigQueryQuery" : "editBigQueryQueries"]({ ...props.formDefaultValue, name, query: { value: bigQueryInput.value.query, type: bigQueryInput.type } });
                    props.done();
                } catch (error) {
                    console.log("error", error);
                }
            }

            const onSaveAsNewRecord = async () => {
                const queryName = prompt("Please enter your name");
                await bigQueryQueriesService.createBigQueryQuery({ name: queryName, query: { value: bigQueryInput.value.query, type: bigQueryInput.type } });
                props.done();
            }

            const onFieldChange = ({ target }) => {
                setFormValue({ ...formValue, [target.name]: target.value })
            }

            const onSQLFileChange = (selectValue) => {
                const sqlFileQuery = bigQuerySQLs.find(({ value }) => value === selectValue)
                setFormValue(sqlFileQuery?.props?.reduce((obj, { defaultValue, name }) => ({ ...obj, [name]: defaultValue }), {}))
                setBigQueryInput({ ...bigQueryInput, value: sqlFileQuery })
            }

            const onRunSQLQuery = async () => {
                try {
                    const res = await bigQueryQueriesService.runBigQuery({ bigQueryId: props.formDefaultValue?._id !== "new" ? props.formDefaultValue?._id : "", query: bigQueryInput.value.query, props: formValue });
                    setResTableData(res);
                } catch (error) {
                    console.log(error);
                }
            }

            const onDeleteBigQuery = async () => {
                await bigQueryQueriesService.deleteBigQueryQueries([(props.formDefaultValue?._id !== "new" ? ({ _id: props.formDefaultValue?._id }) : ({}))]);
                props.done();
            }

            return (
                <div style={{ textAlign: "left" }}>
                    <Input.Group style={{display:"flex"}}>
                        <Select className='antd-select-file-raw' value={bigQueryInput.type} onChange={throttle((value) => setBigQueryInput({ ...bigQueryInput, type: value, value: bigQuerySQLs[0] }))}>
                            <Option value="file">File</Option>
                            <Option value="raw">Raw</Option>
                        </Select>
                        {bigQueryInput.type === "file" ?
                            <Select style={{ width: '100%' }} value={bigQueryInput.value.value} onChange={throttle(onSQLFileChange)}>
                                {bigQuerySQLs.map((query) => <Option value={query.value}>{query.title}</Option>)}
                            </Select> : ""}
                    </Input.Group>
                    <div>
                        SQL:
                    </div>
                    <div>
                        <Input.TextArea value={bigQueryInput.value.query} onChange={throttle(({ target }) => setBigQueryInput({ ...bigQueryInput, value: { ...bigQueryInput.value, query: target.value } }))} name="sql" cols="50" rows="10" />
                        {bigQueryInput.type === "file" ? bigQueryInput.value?.props?.map((input) => <div>
                            <p>{input.title}</p>
                            <Input {...input} onChange={throttle(onFieldChange)} />
                        </div>) : ""}
                    </div>
                    <ContentPanel dividerOrientation="left" title="Result of big query">
                        <Table columns={bigQueryTableColumns} dataSource={resTableData} />
                    </ContentPanel>
                    <div className={"bigquery-modal-footer"}>
                        <Button style={{ marginRight: "3px" }} onClick={onSaveRecord}>{props.formDefaultValue?._id === "new" ? "Create" : "Update"}</Button>
                        {props.formDefaultValue?._id !== "new" ? <Button style={{ marginRight: "3px" }} onClick={onSaveAsNewRecord}>Save as New</Button> : ""}
                        <Button type="primary" style={{ marginRight: "3px" }} onClick={onRunSQLQuery}>Run</Button>
                        {props.formDefaultValue?._id !== "new" ? <Button style={{ marginRight: "3px" }} onClick={onDeleteBigQuery}>Delete Query</Button> : ""}
                    </div>
                </div>
            )
        },
    },

]
